import { createSelector } from 'reselect';

const selectDetailForOrderSelected = (state) => state.setup_advanced_user_detals_for_order_selected;

export const selectDetailsForOrderSelected = createSelector(
  [selectDetailForOrderSelected],
  (detailsForOrder) => detailsForOrder.details_for_order,
);
